import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const hasValidSupabaseConfig = Boolean(supabaseUrl && supabaseAnonKey);

if (!hasValidSupabaseConfig) {
  console.warn('⚠️ Supabase: variáveis VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY não encontradas. Crie um arquivo .env na raiz do projeto.');
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Tipos para as tabelas do Supabase
export interface Database {
  public: {
    Tables: {
      tenants: {
        Row: {
          id: string;
          name: string;
          domain: string;
          plan: string;
          status: string;
          created_at: string;
          settings: {
            maxUsers: number;
            monthlyMessageLimit: number;
            enabledAIs: string[];
            customBranding: {
              companyName: string;
              primaryColor: string;
            };
            security: {
              twoFactorEnabled: boolean;
              ipRestrictionEnabled: boolean;
              allowedIPs: string[];
              sessionTimeout: number;
              requireStrongPasswords: boolean;
              passwordExpirationDays: number;
            };
            contentRestrictions: {
              enabled: boolean;
              restrictedTopics: string[];
              policyFiles: any[];
              blockSensitiveContent: boolean;
              customInstructions: string;
              moderationLevel: string;
            };
          };
          billing: {
            currentPeriodStart: string;
            currentPeriodEnd: string;
            messagesUsed: number;
            lastPayment: string;
            nextPayment: string;
            pricePerUser: number;
            activeUsers: number;
            paymentMethod: any;
            invoices: any[];
          };
          contact: {
            email: string;
            phone: string;
            address: string;
            industry: string;
            website: string;
            taxId: string;
            companySize: string;
          };
        };
        Insert: {
          id?: string;
          name: string;
          domain: string;
          plan: string;
          status: string;
          created_at?: string;
          settings: any;
          billing: any;
          contact: any;
        };
        Update: {
          id?: string;
          name?: string;
          domain?: string;
          plan?: string;
          status?: string;
          created_at?: string;
          settings?: any;
          billing?: any;
          contact?: any;
        };
      };
      users: {
        Row: {
          id: string;
          name: string;
          email: string;
          tenant_id: string;
          role: string;
          status: string;
          created_at: string;
          last_login: string | null;
          two_factor_enabled: boolean;
        };
        Insert: {
          id?: string;
          name: string;
          email: string;
          tenant_id: string;
          role: string;
          status: string;
          created_at?: string;
          last_login?: string | null;
          two_factor_enabled?: boolean;
        };
        Update: {
          id?: string;
          name?: string;
          email?: string;
          tenant_id?: string;
          role?: string;
          status?: string;
          created_at?: string;
          last_login?: string | null;
          two_factor_enabled?: boolean;
        };
      };
      conversations: {
        Row: {
          id: string;
          user_id: string;
          tenant_id: string;
          ai_id: string;
          model_id: string;
          title: string;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          tenant_id: string;
          ai_id: string;
          model_id: string;
          title: string;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          user_id?: string;
          tenant_id?: string;
          ai_id?: string;
          model_id?: string;
          title?: string;
          created_at?: string;
          updated_at?: string;
        };
      };
      messages: {
        Row: {
          id: string;
          conversation_id: string;
          content: string;
          role: string;
          model_id: string | null;
          model_name: string | null;
          created_at: string;
        };
        Insert: {
          id?: string;
          conversation_id: string;
          content: string;
          role: string;
          model_id?: string | null;
          model_name?: string | null;
          created_at?: string;
        };
        Update: {
          id?: string;
          conversation_id?: string;
          content?: string;
          role?: string;
          model_id?: string | null;
          model_name?: string | null;
          created_at?: string;
        };
      };
    };
  };
} 